import { CareActionType } from './care.redux';
import { AnimationState } from '../appearance/appearance.config';
import { CareItem } from 'src/replicant/buruburu/care/care.ruleset';
import { assertNever } from 'src/replicant/utils';
import { Position } from '../position/PositionModel';

export const careActionAnimations: Record<CareActionType, AnimationState> = {
  toy: 'play',
  bath: 'bath',
  toilet: 'toilet',
  food: 'eat',
  snack: 'eat',
  firstAid: 'eat',
  evolve: 'evolve',
  ascension: 'ascension',
};

export function getCareItemPosition(
  item: CareItem,
  isVisitingFriend = false,
  isFriend = false,
): Position {
  switch (item.type) {
    case 'first_aid':
      return {
        scene: isVisitingFriend ? 'friendsLivingRoom' : 'livingRoom',
        location: !isVisitingFriend
          ? 'floorLeft'
          : isFriend
          ? 'rm'
          : 'floorLeft',
      };

    case 'snack':
    case 'food':
      return {
        scene: 'diningRoom',
        location: !isVisitingFriend
          ? 'plate'
          : isFriend
          ? 'plateFriend'
          : 'platePlayer',
      };

    case 'toy':
      return getToyPosition(item.id, isVisitingFriend);

    // Not applicable.
    case 'invitation':
      return null;

    default:
      assertNever(item);
  }
}

function getToyPosition(
  itemId: Extract<CareItem, { type: 'toy' }>['id'],
  isVisitingFriend = false,
): Position {
  const scene = isVisitingFriend ? 'friendsLivingRoom' : 'livingRoom';

  switch (itemId) {
    case 't_autoPilotAirplane_a':
    case 't_autoPilotAirplane_y':
      return {
        scene,
        location: 'aboveLeft',
      };

    case 't_commonBell_a':
    case 't_commonBell_b':
    case 't_commonBell_k':
    case 't_commonBell_y':
      return {
        scene,
        location: isVisitingFriend ? 'frontCenter' : 'frontLeft',
      };

    case 't_fairytaleUnicorn_a':
    case 't_fairytaleUnicorn_y':
    case 't_woollyCaterpillar_a':
    case 't_woollyCaterpillar_k':
    case 't_woollyCaterpillar_y':
      return {
        scene,
        location: isVisitingFriend ? 'floorRight' : 'floorFarRight',
      };

    case 't_doremiPiano_a':
    case 't_emptyMagicLamp_a':
    case 't_noSurpriseJackInTheBox_a':
    case 't_noSurpriseJackInTheBox_k':
    case 't_noSurpriseJackInTheBox_y':
      return {
        scene,
        location: isVisitingFriend ? 'c' : 'floorLeft',
      };

    default:
      return {
        scene,
        location: 'c',
      };
  }
}
